import styled from "styled-components";
import { ClientSettingsDropdownListItemSelectDefaultBox } from "./dropdown-list-item-select.default.box";
import { grayColors } from "../../../../../../../themes/architecture/gray-colors";

export const ClientSettingsDropdownListItemSelectMrGreenBox = styled(ClientSettingsDropdownListItemSelectDefaultBox)`
    background-color: ${({ isSelected, theme }) => isSelected ? theme.colors.brandSecondaryLight : grayColors.gray233};

    svg {
        color: ${grayColors.white};
    }
`